<template>
  <div class="phone-summary">
    <div
      class="d-flex flex-wrap"
      style="gap: 4px 16px"
    >
      <span v-if="data.number"><strong>Número:</strong> {{ data.number }}</span>
      <span v-if="data.imei"><strong>IMEI:</strong> {{ data.imei }}</span>
      <span v-if="data.carrier"><strong>Operadora:</strong> {{ data.carrier }}</span>
      <span v-if="data.owner_name"><strong>Titular:</strong> {{ data.owner_name }}</span>
    </div>
    <div
      v-if="data.observation"
      class="text-muted small mt-1"
    >
      {{ data.observation }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhoneSummary',
  props: {
    data: { type: Object, default: () => ({}) },
  },
}
</script>
